import React, { Children, cloneElement, forwardRef } from "react";
import classNames from "classnames";
import Validation from "./Validation";

export const ChecksGroup = forwardRef(
  (
    {
      id,
      className,
      children,
      isInline,
      isValid,
      isTouched,
      invalidFeedback,
      validFeedback,
      isTooltipFeedback,
      ...props
    },
    ref,
  ) => {
    return (
      <>
        <div
          ref={ref}
          id={id}
          className={classNames(
            {
              "is-invalid": !isValid && isTouched && invalidFeedback,
              "is-valid": !isValid && isTouched && !invalidFeedback,
            },
            className,
          )}
          {...props}
        >
          {Children.map(children, (child) =>
            cloneElement(child, {
              isInline: child.props.isInline || isInline,
              isValid,
              isTouched,
              invalidFeedback,
              validFeedback,
              isTooltipFeedback,
              isValidMessage: false,
            }),
          )}
        </div>
        <Validation
          isTouched={isTouched}
          invalidFeedback={invalidFeedback}
          validFeedback={validFeedback}
          isTooltip={isTooltipFeedback}
        />
      </>
    );
  },
);

const Checks = forwardRef(
  (
    {
      id,
      className,
      name,
      type = "checkbox",
      label,
      value,
      checked = false,
      disabled = false,
      isInline,
      isFormCheckInput,
      isValid,
      isTouched,
      invalidFeedback,
      validFeedback,
      isValidMessage = true,
      isTooltipFeedback,
      onBlur,
      onChange,
      onFocus,
      onInput,
      onInvalid,
      onSelect,
      ariaLabel,
      ...props
    },
    ref,
  ) => {
    const INNER = (
      <input
        ref={ref}
        className={classNames(
          "form-check-input",
          {
            "mt-0": isFormCheckInput,
            "is-invalid": !isValid && isTouched && invalidFeedback,
            "is-valid": !isValid && isTouched && !invalidFeedback,
          },
          className,
        )}
        name={name === null ? id : name}
        type={type === "radio" ? "radio" : "checkbox"}
        id={id}
        value={value}
        checked={type === "radio" ? checked === value : !!checked}
        disabled={disabled}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onInput={onInput}
        onInvalid={onInvalid}
        onSelect={onSelect}
        aria-label={ariaLabel}
        {...props}
      />
    );

    if (isFormCheckInput) {
      return INNER;
    }
    return (
      <div
        className={classNames(
          "form-check",
          {
            "form-switch": type === "switch",
            "form-check-inline": isInline,
          },
          className,
        )}
      >
        {INNER}
        {label && (
          <label className="form-check-label" htmlFor={id}>
            {label}
          </label>
        )}
        {isValidMessage && (
          <Validation
            isTouched={isTouched}
            invalidFeedback={invalidFeedback}
            validFeedback={validFeedback}
            isTooltip={isTooltipFeedback}
          />
        )}
      </div>
    );
  },
);

export default Checks;